import * as angular from 'angular';

import server from '../../integration/server/server-module';
import appStatusController from './appStatus-controllers';

export default angular.module('dataforvalter.status', [server])
    .controller('appStatusController', appStatusController)
    .name;
